import { Title5 } from '../typography';
import { Avatar, type BgColorVariant } from './Avatar';

export interface HeadlineAvatarProps {
  headline: string;
  firstName: string;
  imageSrc?: string;
  avatarBgColor?: BgColorVariant;
  avatarSize?: number;
}

export function HeadlineAvatar({
  headline,
  firstName,
  imageSrc,
  avatarBgColor,
  avatarSize,
}: HeadlineAvatarProps) {
  return 'Not implemented yet!';
  // return (
  //   <div className="flex items-center">
  //     <Avatar
  //       firstName={firstName}
  //       imageSrc={imageSrc}
  //       bgColor={avatarBgColor}
  //       size={avatarSize}
  //     />
  //     <div className="ml-md">
  //       <Title5 as="p">{headline}</Title5>
  //     </div>
  //   </div>
  // );
}
